import { gql } from "../../../../../gql/__generated__/gql";

export const CREATE_REVIEW = gql(`
  mutation createReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      id
      reviewerType
      reviewerId
      revieweeId
      rating
      comment
      createdAt
    }
  }
`);
